import { api } from './apiInstances';

export const postTemplateGrid = async (body) => {
  const result = await api.post('/v1/PlantillaParteTrabajo/grid', body);

  return result.data;
};

// Delete Template
export const deleteTemplateWorkReport = async (ids) => {
  const result = await api.delete('/v1/PlantillaParteTrabajo', {
    data: ids
  });

  return result.data;
};

export const deleteTemplate = async (ids) => {
  const result = await api.delete('/v1/PlantillaParteTrabajo', {
    data: ids
  });

  return result.data;
};

// Modal Aplicar plantillas a SDS-ASDS
export const postApplyTemplate = async (id, idSolicitud, confirmado, body) => {
  const result = await api.post(
    `v1/PlantillaParteTrabajo/${id}/solicitudesServicio/${idSolicitud}?confirmado=${confirmado}`,
    body
  );

  return result.data;
};

// Modal Aplicar plantillas a MSDS

export const postMonthlyApplyTemplate = async (id, idSolicitud, confirmado, body) => {
  const baseUrl = `v1/PlantillaParteTrabajo/${id}/solicitudesServicioMensualizada`;
  const result = await api.post(`${baseUrl}/${idSolicitud}?confirmado=${confirmado}`, body);

  return result.data;
};

/** @param {{id: number, idSolicitud: number}} */
export const applyMSDSTemplate = async ({ id, idSolicitud }, body) => {
  const { data } = await api.post(
    `/v1/PlantillaParteTrabajo/${id}/solicitudesServicioMensualizada/${idSolicitud}`,
    body
  );

  return data;
};

// Modal Generación de plantilla

export const getGenerateTemplateModal = async (id) => {
  const result = await api.get(`v1/PlantillaParteTrabajo/solicitudesServicio/${id}/lineas`);

  return result.data;
};

// Editar los Datos para una plantilla, nombre, y linea
export const putEditTemplate = async (id, body) => {
  const result = await api.put(`/v1/PlantillaParteTrabajo`, body);

  return result.data;
};

export const postCreateTemplate = async (body) => {
  const result = await api.post(`/v1/PlantillaParteTrabajo`, body);

  return result.data;
};

export const getDetailOfTemplate = async (id) => {
  const result = await api.get(`/v1/PlantillaParteTrabajo/${id}`);

  return result.data;
};

// Obtener las lineas de una solicitud
export const getLinesxRequest = async (idSolicitud) => {
  const result = await api.get(
    `/v1/PlantillaParteTrabajo/solicitudesServicio/${idSolicitud}/lineas`
  );

  return result.data;
};

// Modificar el tipo de plantilla
export const changeTemplateType = async (id, isMonthly) => {
  const result = await api.put(
    `/v1/PlantillaParteTrabajo/${id}/modificacionTipoPlantilla?esMensualizada=${isMonthly}`
  );

  return result.data;
};
